import {styled} from 'common'

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    align-items: flex-start;
    display: flex;
    flex-direction: column;

    ${({centered}) =>
        centered &&
        `
        align-items: center;
    `}

    ${({flexed}) =>
        flexed &&
        `
        flex: 1;
    `}
`
export default PageContent
